export const CANVAS_RESET = Symbol('canvasReset');
export const CANVAS_START = Symbol('canvasStart');
export const CANVAS_STOP = Symbol('canvasStop');
